exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-body {\n  -webkit-box-flex:3;\n      -ms-flex-positive:3;\n          flex-grow:3\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/modules/request/request-filter/request-filter.component.css
// module id = ../../../../../src/app/modules/request/request-filter/request-filter.component.css
// module chunks = main